import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type Props = {
	onDismiss?: () => void;
};

type UseFreePromotionFulfillmentReturn = ModelHookResult<
	{ signatures: number; signaturesLocalized: string | number },
	{ handleDismiss: () => void }
>;

export function useFreePromotionFulfillment({ onDismiss }: Props = {}): UseFreePromotionFulfillmentReturn {
	const { data } = useStarterDashboardV2PageData();

	const freePromotions = data.petition.freePromotions ?? [];
	const autoFreePromotion = freePromotions.find((promotion) =>
		promotion.sourceLocation?.startsWith('auto_free_promotion'),
	);
	const signatures = autoFreePromotion?.stats?.signatureCount ?? 0;
	const signaturesLocalized = autoFreePromotion?.stats?.signatureCountLocalized ?? 0;

	const handleDismiss = useCallback(() => {
		onDismiss?.();
	}, [onDismiss]);

	return {
		data: { signatures, signaturesLocalized },
		actions: { handleDismiss },
	};
}
